/**
 * @file Constants relating to authentication.
 */

/**
 * @enum AUTH_TYPE
 * @type {{PHONE: string, EMAIL: string}}
 */
const AUTH_TYPE = {
  PHONE: 'phone',
  EMAIL: 'email',
};

/**
 * @alias PHONE_VERIFY_INTENT
 * @type {{LOGIN: string, ACCOUNT_PHONE_UPDATE: string}}
 */
const PHONE_VERIFY_INTENT = {
  LOGIN: 'LOGIN',
  ACCOUNT_PHONE_UPDATE: 'ACCOUNT_PHONE_UPDATE',
};

/**
 * @alias EMAIL_AUTH_INTENT
 * @type {{LOGIN: string, EMAIL_UPDATE: string}}
 */
const EMAIL_AUTH_INTENT = {
  LOGIN: 'LOGIN',
  EMAIL_UPDATE: 'EMAIL_UPDATE',
};

export { AUTH_TYPE, PHONE_VERIFY_INTENT, EMAIL_AUTH_INTENT };
